import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { updateExpired } from "../../../server/InventoryUpdate";

const ProductLocationTable = ({
  locations,
  generalZones,
  selectedRow,
  hasReturn,
  handleRowClick,
}) => {
  const { stockType } = useSelector((state) => ({
    stationId: state.user.stationId,
    selectedProduct: state.selectedProduct.product,
    items: state.displayProduct.itemsShow,
    stockType: state.parameters.stock_type,
  }));

  useEffect(() => {
    setLocationsRows(locations);
  }, [locations]);

  const [locationsRows, setLocationsRows] = useState(locations);
  const [editingCell, setEditingCell] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const explanations = ["טור", "מדף", "תא"];

  const startEditing = (locationId, currentDate, event) => {
    event.stopPropagation();
    setEditingCell(locationId);
    const dateValue = currentDate
      ? new Date(currentDate).toISOString().split("T")[0]
      : "";
    setEditValue(dateValue);
  };

  const cancelEditing = (event) => {
    event.stopPropagation();
    setEditingCell(null);
    setEditValue("");
  };

  const saveDate = (locationId, event) => {
    event.stopPropagation();

    if (!editValue) {
      cancelEditing(event);
      return;
    }

    const data = {
      id: locationId,
      expired: editValue,
    };

    updateExpired(data)
      .then((res) => {
        setEditingCell(null);
        setEditValue("");
        setLocationsRows(
          locationsRows.map((loc) =>
            loc.Id === locationId ? { ...loc, Expired: editValue } : loc,
          ),
        );
      })
      .catch((error) => {
        console.error("error update expired: ", error);
      });
  };

  const handleKeyPress = (event, locationId) => {
    event.stopPropagation();

    if (event.key === "Enter") {
      saveDate(locationId, event);
    } else if (event.key === "Escape") {
      cancelEditing(event);
    }
  };

  const getGeneralZoneStatus = (zoneId) => {
    return generalZones?.find((z) => z.id === zoneId)?.status || "-";
  };

  return (
    <div className="product-location-table">
      <table>
        <tbody>
          <tr>
            <th>מיקום</th>
            <th>כמות</th>
            <th>כמות זמינה</th>
            <th>תוקף</th>
            <th>מצב מלאי</th>
          </tr>
          {locationsRows.length ? (
            locationsRows.map((x) => (
              <tr
                className={
                  selectedRow?.id === x.id
                    ? "location-row active"
                    : "location-row"
                }
                key={x.Id}
                onClick={() => handleRowClick(x)}
              >
                <td>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                      {x.zoneName}
                    </div>
                    {x.spotId
                      ?.split("-")
                      .slice(1)
                      .map((part, index) =>
                        explanations[index] ? (
                          <div key={index}>
                            {explanations[index]}: {part.trim()}
                          </div>
                        ) : null,
                      )}
                  </div>
                </td>
                <td>{x.quantity}</td>
                <td>{x.quantity}</td>
                <td className="date-cell">
                  {editingCell === x.Id ? (
                    <div
                      className="date-edit-container"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        onKeyDown={(e) => handleKeyPress(e, x.Id)}
                        className="date-input"
                        disabled={isLoading}
                        autoFocus
                      />
                      <div className="date-actions">
                        <button
                          onClick={(e) => saveDate(x.Id, e)}
                          disabled={isLoading}
                          className="save-btn"
                          title="שמור"
                        >
                          ✓
                        </button>
                        <button
                          onClick={cancelEditing}
                          disabled={isLoading}
                          className="cancel-btn"
                          title="ביטול"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  ) : (
                    <span
                      className="date-display"
                      onClick={(e) => startEditing(x.Id, x.expiration, e)}
                      title="לחץ לעריכה"
                    >
                      {x.expiration
                        ? new Date(x.Expired).toLocaleDateString("en-GB")
                        : "-"}
                    </span>
                  )}
                </td>
                <td>{getGeneralZoneStatus(x.zoneId)}</td>
              </tr>
            ))
          ) : hasReturn ? (
            <tr>
              <td colSpan="5">לא נמצאו מיקומים במלאי</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};

export default ProductLocationTable;
